import React from "react";
import { SquareSquare } from "lucide-react";

/**
 * Get icon for button press widgets
 * @param {object} widget - Full widget object (optional, for accessing current state)
 * @returns {JSX.Element} Icon component
 */
export const getButtonPressIcon = (widget = null) => {
  const lucideIconProps = {
    size: 24,
    style: { paddingBottom: "2px" },
  };

  return <SquareSquare {...lucideIconProps} />;
};

export const getButtonPressSubtitle = (widget = null) => {
  if (!widget) return "";

  const buttonState = widget?.items?.$w1?.value;
  const isPressed = !!buttonState;

  return isPressed ? "Pressed" : "Ready";
};

/**
 * Get patterns that this helper supports
 * @returns {string[]} Array of pattern strings
 */
export const getButtonPressPatterns = () => {
  return ["basic.device.buttonPress"];
};
